import styled from 'styled-components';

export const CampaignNameFieldText = styled.span`
    text-overflow: ellipsis;
    margin-left: 32px;
    font-weight: 'regular';
    font-size: 14px;
`;

export const CampaignNameFieldIcon = styled.div`
    min-height: 49px;
    min-width: 49px;
    background: white;
    display: flex;
    align-items: center;
    place-content: center;
    border-radius: 50%;
`;

export const CampaignNameFieldWrapper = styled.div.attrs(() => ({
    className: 'CampaignNameField',
}))`
    align-items: center;
    display: flex;
    height: 48px;
    background: rgb(241, 245, 249);
`;
